import type { UserActivityAction, UserActivityLogPayload } from '@ai-meeting/shared'
import { apiClient } from './api'

/** What the caller says about the press, beyond which press it was. */
type ActivityContext = Omit<UserActivityLogPayload, 'action'>

/**
 * Record that somebody used a feature (BRAI-677).
 *
 * Returns nothing, on purpose. This is counted, not acted on: a caller that
 * could await it would eventually be written to await it, and then a feature
 * would wait on its own statistics before doing what it was pressed for.
 *
 * Failures are swallowed for the same reason. A report with a gap in it is a
 * smaller problem than a meeting that would not start because the row saying
 * somebody started one could not be written.
 *
 * The press is what is recorded, not the outcome, so callers whose action can
 * fail should log both ways rather than only the one that worked — a feature
 * that fails half the time must not read as half as used.
 *
 * @param action Which feature, from the list shared with the server.
 * @param context The meeting and project it happened in, and how it went.
 */
export function logActivity(action: UserActivityAction, context: ActivityContext = {}): void {
  void apiClient.post('/api/activity', { action, ...context }).catch(() => {
    // Deliberately silent: see above.
  })
}
